var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    _vm._g(_vm._b({}, "table", _vm.attributes, false), _vm.events),
    [
      _vm.caption
        ? _c("grid-caption", _vm._b({}, "grid-caption", _vm.caption, false))
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.colgroups, function(colgroup) {
        return _c(
          "grid-colgroup",
          _vm._b({ key: colgroup.key }, "grid-colgroup", colgroup, false)
        )
      }),
      _vm._v(" "),
      _vm.thead
        ? _c("grid-section", _vm._b({}, "grid-section", _vm.thead, false))
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tbodies, function(tbody) {
        return _c(
          "grid-section",
          _vm._b({ key: tbody.key }, "grid-section", tbody, false)
        )
      }),
      _vm._v(" "),
      _vm.tfoot
        ? _c("grid-section", _vm._b({}, "grid-section", _vm.tfoot, false))
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ff45f8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff45f8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/renderer/grid-table.vue
// module id = 32
// module chunks = 0